// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".colored-widget[data-v-238a1c67]{width:228px;fill:#fff;filter:drop-shadow(0 10px 60px rgba(0,0,0,.05))}@media(max-width:1279px){.colored-widget[data-v-238a1c67]{width:163px}}@media(max-width:767px){.colored-widget[data-v-238a1c67]{width:172px}}@media(max-width:399px){.colored-widget[data-v-238a1c67]{width:161px}}.colored-widget .colored-widget__title[data-v-238a1c67]{font-weight:600;font-style:normal;line-height:24.3px;letter-spacing:-.18px;font-size:18px}", ""]);
// Exports
module.exports = exports;
